module.exports = __webpack_public_path__ + "static/img/k_car.1e77c614.png";